import HowToVideo from '../components/HowToVideo'
import HowToRow from '../components/HowToRow'
import VideoModal from '../components/materials/VideoModal'
import { createApp } from 'vue';
import { createPinia } from 'pinia'
import PrintDropdown from '../components/PrintDropdown';

const pinia = createPinia();

if (document.getElementById('how-to-row')) {
    
    const app = createApp({
        components: {
            HowToVideo,
            HowToRow,
            PrintDropdown,
        },
        data() {
            return {
                video: {
                    title: 'Go NAP SACC How-To Video: Self-Assessment',
                    assessmentURL: 'https://www.youtube.com/embed/iLLjYLEJqrA?ecver=2&modestbranding=1&autoplay=0&showinfo=0&enablejsapi=1&rel=0'
                }
            };
        }
    });

    app.use(pinia)
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#how-to-row');
}

import ProgramAssessments from '../components/ProgramAssessments'
if (document.getElementById('assessments_component')) {
    const app2 = createApp({
        components: {
            'assessments': ProgramAssessments
        },
        onSetVideoUrl() {
            console.log('set-video-url')
        }
    });
    app2.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app2.mount('#assessments_component');
}

if(document.getElementById('how-to-video-modal-container')) {
    const app3 = createApp({
        components: {
            VideoModal
        }
    });

    app3.use(pinia)
    app3.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app3.mount('#how-to-video-modal-container');
}

